import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useCloseBom } from "../../api/boms";
import useEncodedBomId from "../../hooks/useEncodedBomId";
import useBomWizardStore from "../../stores/bomWizardStore";
import useQualificationModalStore from "../../stores/qualificationModalStore";

export default function useSubmitForQualification() {
  const [errorMsg, setErrorMsg] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { mutateAsync: closeBom } = useCloseBom();
  const bomId = useBomWizardStore((s) => s.bomId);
  const navigate = useNavigate();
  const { encodedBomId } = useEncodedBomId(bomId);

  const handleCancel = useCallback(() => {
    useBomWizardStore.getState().clearState();
    useQualificationModalStore.getState().toggleModal();
  }, []);

  const handleSubmit = useCallback(() => {
    setErrorMsg(null);
    setSubmitting(true);
    closeBom(bomId)
      .then(() => {
        setSubmitting(false);
        useBomWizardStore.getState().clearState();
        useQualificationModalStore.getState().setShow(false);
        navigate(`/dashboard/bom/${encodedBomId}`);
      })
      .catch((err) => {
        setErrorMsg(JSON.stringify(err.data || "Failed to submit. Please try again."));
      })
      .finally(() => {
        setSubmitting(false);
      });
  }, [closeBom, bomId, navigate, encodedBomId]);

  return useMemo(
    () => ({
      handleCancel,
      handleSubmit,
      errorMsg,
      submitting,
    }),
    [handleCancel, handleSubmit, errorMsg, submitting],
  );
}
